import React, { useEffect, useState } from "react";
import Nearbyrest from "./Nearbyrest";
import Topcuisines from "./Topcuisines";
import Foodtag from "../common/Foodtag";
import useCurrentPosition from "../../helpers/customHooks/useCurrentPosition";
import SearchField from "./SearchField";
import { useNavigate } from "react-router-dom";
import { http } from "../../helpers/http";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import { clearCart } from "../../helpers/help";

const Home = () => {
  const { latitudeData, longitudeData } = useCurrentPosition();
  const [location, setLocation] = useState([]);
  const navigate = useNavigate();
  const [selectedLocation, setSelectedLocation] = useState('');
  const [modalLocation, setModalLocation] = useState('');
  const [modal, setModal] = useState(false);

  useEffect(() => {
    locationDropdown();
  }, []);

  useEffect(() => {
    if (sessionStorage.getItem("__takk_out") && sessionStorage.getItem("_current_location") && JSON.parse(sessionStorage.getItem("__takk_out"))?.type != 'no') {
      if (JSON.parse(sessionStorage.getItem("__takk_out"))?.type === 'yes') {
        setSelectedLocation(JSON.parse(sessionStorage.getItem("__takk_out"))?.located_at);
      }
    }
  }, [sessionStorage.getItem("__takk_out")])

  const locationDropdown = () => {
    http(
      {
        method: "GET",
        url: "getloginSetting",
        isSecure: true
      },
      (response) => {
        setLocation(response.located_at);
        if (!sessionStorage.getItem("_current_location")) {
          console.log('inside');
          sessionStorage.setItem("_current_location", sessionStorage.getItem("__takk_out") ? JSON.parse(sessionStorage.getItem("__takk_out"))?.located_at : 'st_croix')
        }
        if (sessionStorage.getItem("_current_location")) {
          setSelectedLocation(sessionStorage.getItem("_current_location"))
        } else {
          setSelectedLocation('st_croix');
        }
      },
      (error) => {
        toast.error(error.errorMessage);
      }
    );
  }
  

  const submitHandler = (event) => {
    event.preventDefault();
    navigate(`/restaurants`);
  };

  const handleRadioButtonChange = (area) => {
    setModalLocation(area.name); // Update the modal location
    setModal(true); // Open the modal
  };


  const userUpdateProfile = () => {

    const userData = JSON.parse(sessionStorage.getItem("__takk_out"));
    console.log('userData', userData);
    if (userData) {
      const formData = new FormData();
      formData.append('image', null);
      formData.append('userName', userData?.userName);
      formData.append('located_at', sessionStorage.getItem("_current_location"));
      formData.append('email', userData?.email);
      formData.append('countryCode', userData?.countryCode);
      formData.append('mobileNumber', userData?.mobileNumber);
      formData.append(' short_interest_survey', userData?.short_interest_survey && userData?.short_interest_survey === "null" ? "" : userData?.short_interest_survey);
      http(

        {
          method: "POST",
          url: "updateProfile",
          isSecure: true,
          contentType: "multipart/form-data",
          body: formData

        },
        () => {
        }
      )
    }
  }

  const handleNoButtonClick = () => {
    setModal(false); // Close the modal
  };

  const handleYesButtonClick = () => {
    setSelectedLocation(modalLocation); // Update the selected location
    setModal(false); // Close the modal
    if (sessionStorage.getItem("__takk_out")) {
      let takkOut = JSON.parse(sessionStorage.getItem("__takk_out"));
      takkOut.located_at = modalLocation;
      sessionStorage.setItem('__takk_out', JSON.stringify(takkOut));
      sessionStorage.setItem("_current_location", modalLocation);
      userUpdateProfile();
    } else {
      sessionStorage.setItem("_current_location", modalLocation)
    }
    clearCart();

  };

  return (
    <div>
      <main>
        <form onSubmit={submitHandler}>
          <div className="cus_container">
            <div className="d-flex align-items-center justify-content-end pt-4">
              <p className="mb-0 mr-5">Select Location :</p>
              {location.map((area, index) => index > 0 && (
                <div className="radio-group ms-0 d-flex justify-content-start align-items-center mr-5" key={index}>
                  <label className="checkbox-btn mb-def">
                    <input
                      type="radio"
                      name="carddefault"
                      checked={area.name === selectedLocation}
                      onChange={() => handleRadioButtonChange(area)}
                      value={area.name}
                    />
                    <span className="checkmark"></span>
                  </label>
                  <label className="ml-0" htmlFor="">{area.displayName}</label>
                </div>
              ))}
            </div>
            <div className="main-banner-bg mt-4">
              <div className="d-flex align-items-center justify-content-between">
                <div className="col-left">
                  <h1 className="head1 text-white">
                    Make Life Healthy <br /> with <span className="logo_banner">Boomerang</span>
                  </h1>
                  <p className="txt mb-0 text-white">
                    Here you will find all the best quality & pure food. Order now
                    to satisfy your hunger pages.
                  </p>
                  <button className="cusbtn mt-4">Order Now</button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </main>
      <Nearbyrest />
      <Modal
        show={modal}
        onHide={() => setModal(false)}
        centered
        className="logoutmodal center-close-icon"
      >
        <Modal.Header closeButton></Modal.Header>
        <div className="bodyModal">
          <p className="txt text-center mb-2">Hey, looks like you are in</p>
          <h4 className="font-bold text-center">{modalLocation == 'st_thomas' ? 'St. Croix' : 'St. Thomas'}</h4>
          <div className="footerM text-center mt-4">
            <button
              className="cusbtn me-3 minonehunt"
              onClick={handleYesButtonClick}
            >
              Yes, Switch Location
            </button>
            <button
              className="hoverbtn minonehunt"
              onClick={handleNoButtonClick}
            >
              Don't Switch
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Home;
